<!-- =========================================================================================
    File Name: FormWizardNumberTab.vue
    Description: Form wizard with numbers in tabs
    ----------------------------------------------------------------------------------------
    Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
      Author: Pixinvent
    Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->


<template>
    <div>
        <div v-if="loading">
            loading...
        </div>
        <div v-else-if="activeConsultationInfo" class="vx-row flex justify-center">
            <div class="vx-col vx-col sm:w-4/5 lg:w-2/3 md:w-3/4 px-4 pt-6">
                <vx-card title="" >

                    <div slot="no-body">
                        <img src="https://evolugy.mayfer.software/Evolugy/app-assets/images/pages/login.png" alt="content-img" class="responsive card-img-top">
                    </div>
                    
                    <div>
                        <h5>Paciente Nuevo y Confirmación de Consulta</h5>
                        <p class="mt-3 mx-5">¡Hola! Por favor completa la siguiente información para crear tu perfíl y confirma tu primera consulta.</p>
                    </div>

                    <div class="mt-3">
                        <form-wizard color="rgba(var(--vs-primary), 1)"
                            :title="null"
                            :subtitle="null"
                            @on-complete="formSubmitted"
                            backButtonText="Regresar"
                            next-button-text="Siguiente"
                            finishButtonText="Confirmar"
                        >
                            <tab-content title="Datos Nuevo Paciente" class="mb-5">

                                <!-- tab 1 content -->
                                <div class="vx-row">
                                    <div class="vx-col w-full mt-5">
                                        <vs-input label="Nombre(s)" v-model="currentPatientData.first_name" class="w-full" />
                                    </div>
                                    <div class="vx-col w-full mt-5">
                                        <vs-input label="Apellido(s)" v-model="currentPatientData.last_name" class="w-full" />
                                    </div>
                                    <div class="vx-col w-full mt-5">
                                        <p>Email</p>
                                        <p class="ml-6"> {{currentPatientData.email }} </p>
                                    </div>
                                    <div class="vx-col w-full mt-5">
                                        <p>Sexo</p>
                                        <ul class="ml-2 mt-2">
                                            <li class="ml-3 mb-2">
                                                <vs-radio v-model="currentPatientData.gender" name="sexo" v-validate="''" vs-value="male">
                                                Másculino
                                                </vs-radio>
                                            </li>
                                            <li class="ml-3 mb-2">
                                                <vs-radio v-model="currentPatientData.gender" name="sexo" v-validate="''" vs-value="female">
                                                Femenino
                                                </vs-radio>
                                            </li>
                                        </ul>
                                    </div>
                                    <div class="vx-col  w-full mt-5">
                                        <p>Fecha de Nacimiento</p>
                                        <datepicker 
                                            class="px-5 mb-4" placeholder="Seleccionar Fecha" format="yyyy-MM-dd" 
                                            v-model="currentPatientData.dob"
                                        >
                                        </datepicker>
                                    </div>
                                    <div class="vx-col  w-full mt-5">
                                        <p>Número de Contacto</p>
                                        <div class="vx-row">
                                            <div class="vx-col w-1/3 mt-6">
                                                <v-select placeholder="Código de Extensión" :options="['+502','+503', '+504', '+505']" :dir="$vs.rtl ? 'rtl' : 'ltr'" />
                                            </div>
                                            <div class="vx-col w-2/3 ">
                                                <vs-input label="Celular" placeholder="Celular" v-model="currentPatientData.phone[0]"/>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="vx-col  w-full mt-5">
                                        <p>Identificación</p>
                                        <div class="vx-row">
                                            <div class="vx-col w-1/3 mt-6">
                                                <v-select placeholder="Documento" v-model="patientMeta.personal_id_type" :options="['DPI','Cédula', 'Pasaporte']" :dir="$vs.rtl ? 'rtl' : 'ltr'" />
                                            </div>
                                            <div class="vx-col w-2/3 ">
                                                <vs-input label="Identificación" class="inline" placeholder="Identificación" 
                                                    v-model="patientMeta.personal_id"
                                                />
                                            </div>
                                        </div>
                                    </div>
                                    <div class="vx-col w-full mt-5">
                                        <h6>Dirección de Residencia</h6>
                                        <vs-input type="text" label="Dirección"  v-model="currentPatientData.address" class="w-full mt-4" />
                                        <vs-input type="text" label="Complemento de Dirección"  v-model="currentPatientData.address_2" class="w-full mt-4" />
                                        <vs-input type="text" label="Zona"  v-model="currentPatientData.zone" class="w-full mt-4" />
                                        <p class="mt-4">País</p>
                                        <v-select placeholder="Selecciona el País" label="name" v-model="currentPatientData.country" class="mt-2" :options="getCountries" :dir="$vs.rtl ? 'rtl' : 'ltr'" />
                                        <p class="mt-4">Ciudad</p>
                                        <v-select placeholder="Selecciona la ciudad" v-model="currentPatientData.city" class="mt-2" :options="getStates" :dir="$vs.rtl ? 'rtl' : 'ltr'" />
                                    </div>
                                    <div class="vx-col  w-full mt-6 mb-2">
                                        <h5 class="my-2">¿Cómo encontró al doctor?</h5>
                                        <div class="vx-row ">
                                            <div class="vx-col flex flex-col items-center w-full">
                                                <v-select placeholder="Selecciona el origen" class="mt-2 w-1/2" 
                                                    :options="['Google','Referidos', 'Redes Sociales', 'Por mi Seguro', 'Ví su clínica', 'Otro']" :dir="$vs.rtl ? 'rtl' : 'ltr'" v-model="patientMeta.doctorRef"
                                                    />
                                            </div>
                                        </div>
                                    </div>
                                    <div class="vx-col  w-full mt-5" v-if="patientMeta.doctorRef == 'Referidos'">
                                        <p>Persona que lo refirio</p>
                                        <div class="vx-row">
                                            <div class="vx-col w-1/2">
                                                <vs-input class="inputx w-full" placeholder="Nombre" v-model="patientMeta.doctorRef_name" />
                                            </div>
                                            <div class="vx-col w-1/2 ">
                                                <vs-input class="inputx w-full" placeholder="Correo" v-model="patientMeta.doctorRef_email" />
                                            </div>
                                        </div>
                                    </div>
                                    <div class="vx-col  w-full my-5" v-if="patientMeta.doctorRef == 'Referidos'">
                                        <p>Número de referido</p>
                                        <div class="vx-row">
                                            <div class="vx-col w-2/3 ">
                                                <vs-input class="inputx w-full" placeholder="Número de referido" v-model="patientMeta.doctorRef_num" />
                                            </div>
                                        </div>
                                    </div>
                                    <div class="vx-col  w-full mt-5">
                                        <h5>Hace Ejercicio</h5>
                                        <div class="vx-row ">
                                            <div class="vx-col">
                                                <ul class="centerx ml-5 mt-3">
                                                    <li>
                                                        <vs-radio v-model="patientMeta.exercise" :vs-value="true">Si</vs-radio>
                                                    </li>
                                                    <li>
                                                        <vs-radio v-model="patientMeta.exercise" :vs-value="false">No</vs-radio>
                                                    </li>
                                                </ul>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="vx-col  w-full mt-5" v-if="patientMeta.exercise">
                                        <p>Tipo de ejercicio</p>
                                        <div class="vx-row ">
                                            <div class="vx-col flex flex-col items-center w-full">
                                                <v-select placeholder="Tipo de ejercicio" class="mt-2 w-1/2" 
                                                    :options="['Caminar a paso ligero','Caminata regular', 'Trotar', 'Yoga', 'Aerobicos', 'Nadas', 'Bicicleta', 'Correr', 'Otro']" :dir="$vs.rtl ? 'rtl' : 'ltr'" 
                                                    v-model="patientMeta.exerciseType"
                                                    />
                                            </div>
                                        </div>
                                        <p>¿Con qué frecuencia?</p>
                                        <div class="vx-row ">
                                            <div class="vx-col flex flex-col items-center w-full">
                                                <v-select placeholder="Frecuencia de ejercicio" class="mt-2 w-1/2" 
                                                    :options="['Una vez a semana','Dos veces a la semana', 'Tres veces a la semana', 'Cuatro veces a la semana', 'Cinco veces a la semana', 'Seis veces a la semana', 'Todos los días']" :dir="$vs.rtl ? 'rtl' : 'ltr'" 
                                                    v-model="patientMeta.exerciseFreq"
                                                    />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </tab-content>

                            <!-- tab 2 content -->
                            <tab-content title="Cita Médica" class="mb-5">
                                <div class="vx-row">
                                    <div class="vx-col  w-full mt-5">
                                        <h6>Motivo de la Consulta</h6>
                                    </div>
                                    <div class="vx-col  w-full mt-5">
                                        <p>Explique todos los síntomas y/o motivos para su consulta.</p>
                                    </div>
                                    <div class="vx-col sm:w-full md:w-2/3 w-full">
                                        <vs-textarea v-model="consultationDetail.comments_obs" label="Descripción del Motivo de Consulta" class="mb-0 md:mt-10 mt-6" rows="3" />
                                    </div>
                                    <div class="vx-col sm:w-full md:w-1/3 pt-3 w-full">
                                        <h6>Síntomas COVID</h6>
                                        <ul class="centerx ml-4">
                                            <li>
                                                <vs-checkbox class="mt-4 mb-2" v-model="consultationDetail.main_symptoms.fever">Fiebre</vs-checkbox>
                                            </li>
                                            <li>
                                                <vs-checkbox class="mt-4 mb-2" v-model="consultationDetail.main_symptoms.dryCough">Tos Seca</vs-checkbox>
                                            </li>
                                            <li>
                                                <vs-checkbox class="mt-4 mb-2" v-model="consultationDetail.main_symptoms.tiredness">Cansancio</vs-checkbox>
                                            </li>
                                            <li>
                                                <vs-checkbox class="mt-4 mb-2" v-model="consultationDetail.main_symptoms.throatPain">Dolor de Garganta</vs-checkbox>
                                            </li>
                                            <li>
                                                <vs-checkbox class="mt-4 mb-2" v-model="consultationDetail.main_symptoms.diarrhea">Diarrea</vs-checkbox>
                                            </li>
                                            <li>
                                                <vs-checkbox class="mt-4 mb-2" v-model="consultationDetail.main_symptoms.headache">Dolor de Cabeza</vs-checkbox>
                                            </li>
                                            <li>
                                                <vs-checkbox class="mt-4 mb-2" v-model="consultationDetail.main_symptoms.smellTasteLoss">Perdida del sentido del olfato o del gusto</vs-checkbox>
                                            </li>
                                            <li>
                                                <vs-checkbox class="mt-4 mb-2" v-model="consultationDetail.main_symptoms.breathingDifficulty">Dificultad para respirar</vs-checkbox>
                                            </li>
                                            <!-- <li>
                                                <vs-checkbox class="mt-4 mb-2" v-model="consultationDetail.main_symptoms.pressure">Presión alta</vs-checkbox>
                                            </li>
                                            <li>
                                                <vs-checkbox class="mb-2" v-model="consultationDetail.main_symptoms.fever">Fiebre</vs-checkbox>
                                            </li>
                                            <li>
                                                <vs-checkbox class="mb-2" v-model="consultationDetail.main_symptoms.nausea">Nausea</vs-checkbox>
                                            </li>
                                            <li>
                                                <vs-checkbox class="mb-2" v-model="consultationDetail.main_symptoms.tiredness">Cansancio</vs-checkbox>
                                            </li>
                                            <li>
                                                <vs-checkbox class="mb-2" v-model="consultationDetail.main_symptoms.fatigue">Fatiga</vs-checkbox>
                                            </li> -->
                                        </ul>
                                    </div>
                                    <vs-divider></vs-divider>
                                    <div class="vx-col sm:w-full md:w-1/2 w-full">
                                        <h5>Enfermedades</h5>
                                        <p>¿Padece alguna enfermedad o alergia? </p>
                                        <vs-textarea v-model="consultationDetail.diseases" class="mb-0 md:mt-2 mt-2" rows="2" />
                                    </div>
                                    <div class="vx-col sm:w-full md:w-1/2 w-full">
                                        <h5>Medicamentos</h5>
                                        <p>¿Consume algún medicamento? </p>
                                        <vs-textarea v-model="consultationDetail.usedMeds" class="mb-0 md:mt-2 mt-2" rows="2" />
                                    </div>
                                    <div class="vx-col  w-full mt-6">
                                        <h4 class="my-4">Datos de la Cita Médica</h4>
                                    </div>

                                    <div class="vx-col sm:w-full py-6 w-full flex flex-col items-center">
                                        <h6><code class="text-primary">
                                                {{new Date(activeConsultationInfo.date).toLocaleDateString('es-ES', dateStringOptions)}}
                                                -
                                                {{new Date(activeConsultationInfo.date).toLocaleTimeString('en-EN', timeStringOptions)}}
                                            </code>
                                        </h6>
                                        <vs-divider/>
                                        <!-- <calendar
                                            class="mt-6"
                                            title-position="left"
                                            locale="es"
                                            :attributes="miniCalendar"
                                        ></calendar> -->

                                    </div>
                                </div>
                            </tab-content>

                            <!-- tab 3 content -->
                            <tab-content title="Resumen" class="mb-5">
                                <div class="vx-row">
                                    <div class="vx-col  w-full mt-5">
                                        <h6>Datos del Paciente</h6>
                                        <p class="mt-2">
                                            {{currentPatientData.first_name}} {{currentPatientData.last_name}}
                                        </p>
                                        <p class="mt-2">
                                            {{currentPatientData.email}}
                                        </p>
                                    </div>
                                    <div class="vx-col  w-full mt-5">
                                        <h6>Motivo de la Consulta</h6>
                                    </div>
                                    <div class="vx-col  w-full mt-5">
                                        <p> {{consultationDetail.comments_obs}} </p>
                                    </div>
                                    <div class="vx-col  w-full mt-5">
                                        <h6>Fecha y Hora</h6>
                                        <p class="mt-2">
                                            {{new Date(activeConsultationInfo.date).toLocaleDateString('es-ES', dateStringOptions)}}
                                                -
                                            {{new Date(activeConsultationInfo.date).toLocaleTimeString('en-EN', timeStringOptions)}}
                                        </p>
                                    </div>
                                    
                                    <div class="vx-col w-full mt-5 flex flex-col items-center" v-if="false">
                                        <h6 class="my-3">Agregar Recordatorio</h6>
                                        <vs-button class="my-3" color="primary" type="border" >
                                            <img class="inline mr-2" src="https://img.icons8.com/color/30/000000/google-logo.png"/>
                                            Google Calendar
                                        </vs-button>
                                        <vs-button class="my-3" color="primary" type="border" >
                                        <img class="inline mr-2" src="https://img.icons8.com/fluent-systems-filled/30/000000/mac-os.png"/>
                                            Apple Calendar
                                        </vs-button>
                                        <vs-button class="my-3" color="primary" type="border" >
                                        <img class="inline mr-2" src="https://img.icons8.com/color/30/000000/microsoft.png"/>
                                            Microsoft Calendar
                                        </vs-button>
                                    </div>
                                    
                                </div>
                            </tab-content>
                        </form-wizard>
                    </div>
                </vx-card>
            </div>
        </div>
    </div>
</template>

<script>
import {FormWizard, TabContent} from 'vue-form-wizard'
import 'vue-form-wizard/dist/vue-form-wizard.min.css'
import Datepicker from 'vuejs-datepicker';
import vSelect from 'vue-select'
import Calendar from 'v-calendar/lib/components/calendar.umd'

// country state picker functions
import * as CSP from 'country-state-picker';import flatPickr from 'vue-flatpickr-component'
import 'flatpickr/dist/flatpickr.css'
const ES = require("flatpickr/dist/l10n/es.js").default.es;


export default {
  data () {
    return {
      loading: true, 
      patientMeta: {
        height: null,
        weight: null,
        blood_type: null,
        personal_id: null,
        personal_id_type: null,
      },
      currentPatientData: {},
      dateStringOptions:  { weekday: 'long', year: 'numeric', month: 'long', day: 'numeric' },
      timeStringOptions:  { hour: 'numeric', minute: 'numeric', hour12: true },
        miniCalendar: [
            {
            key: 'Hoy',
            highlight: true,
            dates: new Date(),
            readonly: true,
            }
      ],
     consultationDetail: {
        comments_obs: null,
        diseases: [],
        medicaments: [],
        evaluationQuestions: [],
        importantNotes: null,
        physical_exam: null,
        vitalSigns: [],
        vitalSignsArr: [],
        physical_notes: null,
        documents: [],
        cie10: [],
        exams: [],
        meds: [],
        usedMeds: [],
        diagnosis_eval: null,
        nextConsultation: {
          requestNext: false,
          whenQty: null,
          whenFrq: null,
        },
        consultationTotal: 250.00,
        paymentMethod: null,
        main_symptoms: {
          pressure: false,
          fever: false,
          nausea: false,
          tiredness: false,
          fatigue: false
        }
      },
      origen: '',
      exercise: {
          yof: true,
          type: ''
      }
    }
  },
    configdateTimePicker2: {
            enableTime: false,
            dateFormat: 'Y-m-d',
            altInput: true,
            altFormat: 'd M Y',
            defaultDate: new Date(),
            locale: ES
      },
  methods: {
    formSubmitted () {
      this.editPatientEvent();
    },
    editPatientEvent(){
      this.editting = !this.editting;

      console.log(this.patientMeta);
      console.log(this.patientData);
      this.currentPatientData.meta = {...this.currentPatientData.meta ,...this.patientMeta};

        this.$store.dispatch('editUserPublic', this.currentPatientData).then(response => {
            console.log(response);
            var payload = new Object(); 
            payload.event_id = this.activeConsultationInfo.id;
            payload.meta = {...this.activeConsultationInfo.meta, ...this.consultationDetail, ...{"status": "Confirmada"}};
            
            this.$store.dispatch('editEventPublic', payload).then(response => {
                console.log(response);
                window.location.href = '/links/confirm-s';        
            }, error => {
                console.error(error.response);
                
            });
                        
        }, error => {
            console.error(error.response);
            
        });
    },
  },
  computed: {
    activeConsultationInfo () {
        return this.$store.state.publicConsultationInfo
    },
    // currentPatientData(){
    //   return this.$store.state.publicPatient
    // },
    getCountries(){
      return CSP.getCountries();
    },
    getStates(){
      return CSP.getStates(this.currentPatientData.country.code);
    },
  },
  beforeCreate(){
    console.log(this.$route);
    this.$store.dispatch('getConsultationByIdPublic', this.$route.params.event_id).then(response => {
        console.log(response.data);

        this.$store.dispatch('getUserDataByIdPublic', response.data.data.event.patient_id).then(response => {
            console.log(response);
            this.currentPatientData = JSON.parse(JSON.stringify(response.data.data.user));
            if(response.data.data.user.meta){
                this.patientMeta = {...this.patientMeta, ...JSON.parse(JSON.stringify(response.data.data.user.meta))};
            }
            this.loading = false;
            }, error => {
                console.error(error);
            }
        ); 
      }, error => {
          console.error(error);
      });  
  },
  watch: {
    activeConsultationInfo(newVal, oldVal){
         this.miniCalendar.dates = new Date(newVal.date);
    },
  },
  components: {
    FormWizard,
    TabContent,
    Datepicker,
    vSelect,
    Calendar,
    flatPickr
  }
}
</script>
<style scoped>
body{
        touch-action: manipulation;
    }
</style>